export default __webpack_public_path__ + "static/media/form.488bcfc2.png";